import React from 'react'

import { ActivityForm } from './components'

const ActivityEdit = () => <ActivityForm isShow={false} />

export default ActivityEdit
